import { render, staticRenderFns } from "./PropertyMaintenanceSystemSelector.vue?vue&type=template&id=63674ae0"
import script from "./PropertyMaintenanceSystemSelector.vue?vue&type=script&lang=ts"
export * from "./PropertyMaintenanceSystemSelector.vue?vue&type=script&lang=ts"
import style0 from "./PropertyMaintenanceSystemSelector.vue?vue&type=style&index=0&id=63674ae0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports